import styled from "styled-components";

export const Wrapper = styled.div`
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: auto;
  z-index: 1000;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  color: #000;
  margin-bottom: 16px;
`;

export const A = styled.a``;
export const Subtitle = styled.p`
  font-size: 1rem;
  margin-bottom: 16px;

  a {
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const InfoBox = styled.div`
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 16px;
  font-size: 14px;
  color: #555;
  line-height: 1.5;
`;

export const Button2 = styled.button`
  background-color: #e0f2ff;
  color: #007bff;
  font-size: 1rem;
  font-weight: bold;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #d0eaff;
  }
`;

export const Card = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4000;
  top: 11%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  text-align: center;

  @media (max-width: 430px) {
    width: 383px;
    top: 15%;
    left: 50%;
  }
`;

export const StepProgress0 = styled.div`
  width: 100%;
  display: block;
  margin: 0 auto;
  @media (max-width: 430px) {
    width: 383px;
  }
`;

export const StepProgress = styled.div`
  width: 520px;
  margin: 0 auto;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const PopUp = styled.div`
  display: block;
  margin: 0 auto;
  width: 100%;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const FormContainer = styled.div`
  position: absolute;
  display: none;
  top: 0;
  padding-top: 50px;
  left: 0;
  height: 5133px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const SecondContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 550px;
  margin: auto;
  padding: 60px;
  border: 1px solid #dddddd;
  border-radius: 24px;
  background-color: white;

  @media (max-width: 430px) {
    width: 393px;
    border-radius: 0;
  }
`;
export const FormMain = styled.form`
  margin-top: 100px;
`;
export const OptionElement = styled.option``;

export const Cont = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;
export const LabelSmall = styled.label`
  font-family: Avenir Next;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  @media (max-width: 430px) {
    font-size: 10px;
  }
`;

export const PolCheck = styled.a`
  font-family: Avenir Next;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #55749f;
  @media (max-width: 430px) {
    font-size: 10px;
  }
`;
export const Label = styled.label`
  font-family: Avenir Next;
  font-size: 22px;
  font-weight: 400;
  text-align: left;
  margin-bottom: 10px;
`;
export const Input = styled.input`
  margin: 0;
  border: none;
  border-bottom: 1px solid #141414;
  padding-bottom: 5px;
  margin-bottom: 10px;
  outline: none;
  font-size: 1rem;
  &::placeholder {
    color: #dddee4;
  }
`;
export const InputCheckBox = styled.input`
  accent-color: black;
`;

export const Select = styled.select`
  margin: 8px 0;
  border: none;
  border-bottom: 1px solid #141414;
  padding-bottom: 5px;
  outline: none;
`;
export const Div = styled.div`
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 400;
  line-height: 17px;
  text-align: left;
  color: #f4502f;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  margin-bottom: 40px;
  width: 370px;
`;

export const Button = styled.button`
  padding: 5px 10px;
  color: #141414;
  border: none;
  cursor: pointer;
  width: 80px;
  height: 40px;
  background-color: transparent;

  border-radius: 24px;
  border: 1px solid black;

  &:hover {
    background-color: #bfdcf5;
    border: 1px solid #bfdcf5;
  }
`;

export const StepSlider = styled.div`
  width: 100%;
  @media (max-width: 430px) {
    width: 373px;
  }
`;
export const Second = styled.div<{ $isActive?: boolean }>`
  top: -25px;
  z-index: 3000;
  position: absolute;
  margin-left: 80px;
  color: #e0e0e0;
  &:after {
    transition: all 0.3s ease-out 0.5s;
    color: #55749f;
  }

  &:before {
    color: #55749f;
  }

  ${({ $isActive }) =>
    $isActive &&
    `
      color: #55749f;
  `}

  @media (max-width: 430px) {
    margin-left: 50px;
  }
`;
export const StepSliderItem = styled.div<{ $isActive?: boolean }>`
  width: 30%;
  height: 1px;
  position: relative;
  float: left;
  text-align: right;
  background-color: #e0e0e0;

  &:after {
    content: "";
    width: 10px;
    height: 10px;
    position: absolute;
    top: -6px;
    right: 0;
    background-color: #fafafa;
    border: 1px solid #e0e0e0;
    border-radius: 50%;
    z-index: 2;
    transition: all 0.3s ease-out 0.5s;
    color: #55749f;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0%;
    height: 1px;
    background-color: #b0bec5;
    z-index: 1;
    transition: all 0.5s ease-out;
    color: #55749f;
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    &:before {
      width: 100%;
      background-color: #55749f;
      color: #55749f;
    }

    &:after {
      border-color: #55749f;
      color: #55749f;
    }
  `}
`;

export const StepContent = styled.div`
  padding: 16px 0;
  color: #55749f;
`;

export const StepContentFoot = styled.div`
  text-align: right;

  button {
    border: 0;
    padding: 8px 16px;
    background-color: #cfd8dc;
    font-size: 14px;
    border-radius: 3px;
    outline: 0;

    &:active {
      background-color: rgba(255, 255, 255, 0.2);
    }

    &.out {
      display: none;
    }

    &.disable {
      background-color: #eceff1;
    }

    &.active {
      background-color: #00acc1;
      color: white;
    }
  }
`;

export const StepContentBody = styled.div`
  text-align: center;
  font-size: 18px;

  &.out {
    display: none;
  }
  @media (max-width: 430px) {
    width: 383px;
  }
`;

export const Container3 = styled.div`
  position: absolute;
  display: none;
  top: 0;
  padding-top: 50px;
  left: 0;
  height: 5133px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const Container4 = styled.div`
  margin-top: 30px;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 550px;
  margin: 0 auto;
  background-color: #ffffff;
  border-radius: 24px;
  padding: 60px;
  @media (max-width: 430px) {
    width: 393px;
    border-radius: 0;
    padding: 0;
    padding-top: 70px;
    padding-bottom: 70px;
  }
`;
export const Small = styled.div`
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  color: #a7a7a7;
  margin-bottom: 36px;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const H2 = styled.div`
  font-family: Cormorant Infant;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 14px;
  padding: 20px 20px 0px 20px;
  @media (max-width: 430px) {
    width: 393px;
  }
`;

export const NoFree = styled.div`
  font-size: 30px;
  margin: 0 auto;
  margin-bottom: 40px;
  font-family: Avenir Next;
  @media (max-width: 430px) {
  }
`;

export const Container2 = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 430px) {
    width: 363px;
    margin-left: 15px;
  }
`;

export const TimeButton = styled.button<{ selected: boolean }>`
  width: 100px;
  height: 60px;
  margin: 2px;
  display: flex;
  font-size: 20px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 2px solid grey;
  background-color: ${(props) => (props.selected ? "#ffffff" : "#fff")};
  color: ${(props) => (props.selected ? "#000" : "black")};
  border-color: ${(props) => (props.selected ? "#1983FF" : "#EEEFF0")};
  border-radius: 12px;
  margin-bottom: 40px;
  margin-left: 35px;
  @media (max-width: 430px) {
    margin-left: 13px;
  }
`;

export const SubmitButton = styled.button`
  padding: 10px 20px;
  background-color: #bfdcf5;
  color: #141414;
  border: none;
  cursor: pointer;
  width: 350px;
  font-weight: 500;

  border-radius: 24px;
  margin-bottom: 20px;
  border: 1px solid black;

  &:disabled {
    border: none;
    background-color: #dddee4;
    color: black;
    cursor: not-allowed;
  }
  margin-left: 10px;
`;

export const BackButton = styled.button`
  padding: 5px 10px;
  color: #141414;
  border: none;
  cursor: pointer;
  width: 100px;
  height: 40px;
  background-color: transparent;

  border-radius: 24px;
  border: 1px solid black;

  &:hover {
    background-color: #bfdcf5;
    border: 1px solid #bfdcf5;
  }
`;

export const CalendarContainer2 = styled.div`
  position: absolute;
  display: block;
  top: 0;
  padding-top: 50px;
  left: 0;
  height: 5133px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  @media (max-width: 430px) {
    width: 393px;
  }
`;
export const CalendarContainer = styled.div`
  width: 550px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 60px;
  border-radius: 24px;
  @media (max-width: 430px) {
    width: 393px;
    border-radius: 0;
    padding: 0;
    padding-top: 70px;
    padding-bottom: 70px;
  }
`;
export const CalendarContainer3 = styled.div`
  margin-top: 50px;
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 1px solid #dddee4;
  padding: 20px 20px 0px 20px;
  @media (max-width: 430px) {
    padding: 20px;
  }
`;

export const MonthButton = styled.button`
  background-color: transparent;
  color: black;
  font-weight: 600;
  font-size: 20px;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
`;

export const MonthText = styled.span`
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: center;
`;

export const CalendarDays = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 5px;
  color: #55749f;
  font-family: Avenir Next;
  font-size: 1rem;
  text-align: center;
  font-weight: 500;
  margin: 0px 20px 0px 20px;
  width: 330px;
  @media (max-width: 430px) {
    width: 333px;
    margin-left: -8px;
  }
`;
type ImageProps = {
  $img: string;
};

export const X2 = styled.div<ImageProps>`
  z-index: 5000;
  cursor: pointer;
  display: block;
  top: -25px;
  width: 21px;
  height: 21px;
  padding-left: 1000px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  background-position: center;
  @media (max-width: 430px) {
    padding-left: 720px;
  }
`;

export const CalendarGrid2 = styled.div`
  border: 1px solid #dddee4;
  border-radius: 24px;

  width: 375px;
  margin: 0 auto;
  @media (max-width: 430px) {
    border-radius: 0;
    align-items: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
`;

export const CalendarGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0px 20px 0px 20px;
`;

export const H3 = styled.h3`
  font-family: Cormorant Infant;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 36px;
  @media (max-width: 430px) {
    width: 393px;
  }
`;

export const CalendarDay = styled.div<{
  selected?: boolean;
  isPast?: boolean;
  disabled?: boolean;
}>`
  width: 42.5px;
  height: 42.5px;
  margin: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 2px solid white;
  border-radius: 12px;
  background-color: ${(props) => (props.selected ? "#ffffff" : "#fff")};
  color: ${(props) => (props.selected ? "#000" : "#a7a7a7")};
  border-color: ${(props) => (props.selected ? "#1983FF" : "#ffffff")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  pointer-events: ${({ isPast }) => (isPast ? "none" : "auto")};

  color: ${({ disabled, isPast }) => (disabled || isPast ? "#a7a7a7" : "#000")};

  &:hover {
    background-color: ${({ isPast }) => (isPast ? "transparent" : "#f0f0f0")};
    background-color: ${({ disabled }) =>
      disabled ? "transparent" : "#f0f0f0"};
  }
`;

export const ConfirmButton = styled.button`
  padding: 10px 20px;
  background-color: #bfdcf5;
  color: #141414;
  border: none;
  cursor: pointer;
  width: 320px;

  border-radius: 24px;
  margin-top: 10px;
  margin-bottom: 20px;
  margin-left: 20px;
  border: 1px solid black;

  &:disabled {
    border: none;
    background-color: #dddee4;
    cursor: not-allowed;
  }

  @media (max-width: 430px) {
    margin-left: 0;
    width: 270px;
  }
`;
